export default __webpack_public_path__ + "static/media/bx_time-five.6ef23aca.svg";